import React from 'react';
import { useSelector } from 'react-redux';
import { login, logout } from '../../../store/auth/auth-actions';
import Icon from '../../../components/ui/icons/Icon';
import iconsList from '../../../components/ui/icons/iconsList';
import virtualCampusLogoLogout from "../../../assets/header/virtualCampusLogoLogout.png"
import accessibilityIcon from "../../../assets/header/accessibilityIconElementary.svg"
import classes from './UnidentifiedHeader.module.css';
import TranslateBtns from '../../../components/ui/translateBtns/TranslateBtns';
import { AccessibilityClickableDiv, AccessibilityHiddenImg } from '@skillz/accessibility';
const UnidentifiedHeader = () => {

    const { texts } = useSelector(state => state.translate);
    const { isAuth } = useSelector(state => state.auth);

    return (
        <div className={classes.headerContent}>
            <div className={classes.title}>
                <img className={classes.bgLogo} src={virtualCampusLogoLogout} alt="" />
                <div className={classes.TitleWrapper}>
                    <div className={classes.Title}>
                        <p className={classes.TitleSimple}>{`${texts.fromEachPlace},`}</p>
                        <p className={classes.TitleRegular}>{`${texts.inEachTime},`}</p>
                    </div>
                    <p className={classes.TitleBold}>{`${texts.forYou}.`}</p>
                </div>
            </div>
            {/* <div className={classes.link}>
                <a onClick={() => login()}>
                    {texts?.virtualSchoolHostLink}
                </a>
            </div> */}
            <button className={classes.btn} onClick={isAuth === true ? logout : login} >
                {isAuth === true ? texts.logout : texts.login}
                <Icon className={classes.arrowsIcon} name={iconsList.arrows} color={"white"} size="32px" />
            </button>

            <TranslateBtns />
            <AccessibilityClickableDiv className={classes.Accessibility} onClick={() => window.open(texts.accessibilityLink, '_blank')} >
                <AccessibilityHiddenImg src={accessibilityIcon} />
            </AccessibilityClickableDiv>
        </div>
    );
};

export default UnidentifiedHeader;

